/* Round 46: keep pickup messaging aligned with the cart's actual remaining items.
   No changes to prices, discounts, shipping rates or checkout enforcement. */
(function (root, factory) {
  var api = factory(root);
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) {
    root.InStockyDelivery = api;
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', api.init);
    else api.init();
    root.document.addEventListener('shopify:section:load', api.init);
  }
})(typeof window !== 'undefined' ? window : null, function (root) {
  'use strict';
  var config = null;
  function readConfig() {
    if (!root) return { products: {}, strings: {} };
    var node = root.document.getElementById('InStockyCartDeliveryData');
    if (!node) return { products: {}, strings: {} };
    if (config && config.node === node) return config.data;
    try { config = { node: node, data: JSON.parse(node.textContent) }; return config.data; }
    catch (error) { return { products: {}, strings: {} }; }
  }
  function productMode(id) {
    var products = readConfig().products || {};
    return Object.prototype.hasOwnProperty.call(products, String(id)) ? products[String(id)] : 'unknown';
  }
  function classify(items, products) {
    var pickup = 0, other = 0, unknown = 0;
    (items || []).forEach(function (item) {
      if (!(Number(item.quantity) > 0)) return;
      var mode = products[String(item.product_id)];
      if (mode === 'pickup') pickup++;
      else if (mode === 'normal' || mode === 'heavy') other++;
      else unknown++;
    });
    if (unknown) return 'unknown'; // Do not promise shipping for data we have not read.
    return pickup ? (other ? 'mixed' : 'pickup') : 'normal';
  }
  function setText(selector, value) {
    if (!root || typeof value !== 'string') return;
    root.document.querySelectorAll(selector).forEach(function (el) { el.textContent = value; });
  }
  function freeShippingState(cart, products, settings, mode) {
    settings = settings || {};
    if (!cart || !settings.currency) return { visible: false };
    var currency = typeof cart.currency === 'string' ? cart.currency : cart.currency && cart.currency.iso_code;
    currency = currency || settings.cartCurrency;
    var threshold = Number(settings.threshold);
    var total = cart.total_price;
    if (mode === undefined) mode = classify(cart.items, products || {});
    if (mode !== 'normal' || !(Number(cart.item_count) > 0) || cart.requires_shipping !== true ||
        currency !== settings.currency || typeof total !== 'number' || !isFinite(total) || total < 0 ||
        !isFinite(threshold) || threshold <= 0) return { visible: false };
    return {
      visible: true,
      remaining: Math.max(0, Math.round(threshold) - Math.round(total)),
      percent: Math.min(100, Math.max(0, total * 100 / threshold)),
      qualified: total >= threshold
    };
  }
  function formatShippingAmount(cents, locale) {
    // CAD only; keep the initial Liquid and Ajax messages formatted identically.
    var amount = (Math.max(0, cents) / 100).toFixed(2);
    return /^fr(?:-|$)/i.test(locale || '') ? amount.replace('.', ',') + '\u00a0$' : '$' + amount;
  }
  function updateFreeShipping(cart, data, mode) {
    var node = root.document.querySelector('[data-instocky-free-shipping]');
    if (!node) return;
    var settings = data.freeShipping || {};
    var state = freeShippingState(cart, data.products || {}, settings, mode);
    node.hidden = !state.visible;
    if (!state.visible) return;
    var message = node.querySelector('[data-instocky-free-shipping-message]');
    var fill = node.querySelector('[data-instocky-free-shipping-fill]');
    var text = state.qualified ? settings.qualified : settings.remaining;
    if (!message || typeof text !== 'string' || (!state.qualified && text.indexOf('[amount]') === -1)) {
      node.hidden = true;
      return;
    }
    var amount = formatShippingAmount(state.remaining, settings.locale);
    var parts = text.split('[amount]');
    var displayed = state.qualified ? text : parts.join(amount);
    // Text nodes keep translated content and monetary values out of innerHTML.
    if (message.textContent.trim() !== displayed) {
      message.textContent = '';
      if (state.qualified) {
        var success = root.document.createElement('strong');
        success.textContent = text;
        message.appendChild(success);
      } else {
        parts.forEach(function (part, index) {
          if (index > 0) {
            var value = root.document.createElement('strong');
            value.textContent = amount;
            message.appendChild(value);
          }
          message.appendChild(root.document.createTextNode(part));
        });
      }
    }
    node.classList.toggle('instocky-free-shipping--qualified', state.qualified);
    if (fill) fill.style.width = state.percent + '%';
  }
  function updateCart(cart) {
    if (!root || !cart) return;
    var data = readConfig(), strings = data.strings || {};
    var mode = classify(cart.items, data.products || {});
    var special = mode !== 'normal';
    var notice = root.document.querySelector('[data-instocky-cart-delivery-notice]');
    if (notice) notice.hidden = !special;
    var lead = mode === 'normal' ? strings.normalLead : mode === 'unknown' ? strings.unknownLead : strings.pickupLead;
    var benefit = strings[mode + 'Benefit'];
    setText('[data-instocky-cart-lead]', lead);
    setText('[data-instocky-cart-delivery-copy]', strings[mode + 'Notice']);
    setText('[data-instocky-cart-delivery-benefit]', benefit);
    setText('[data-instocky-header-delivery]', benefit);
    var included = typeof cart.taxes_included === 'boolean' ? cart.taxes_included : data.taxesIncluded;
    var taxKey = mode + 'Taxes' + (included && mode !== 'unknown' ? 'Included' : '');
    setText('[data-instocky-cart-tax-delivery]', strings[taxKey]);
    updateFreeShipping(cart, data, mode);
    return mode;
  }
  function init() {
    if (!root || !root.document.getElementById('InStockyCartDeliveryData')) return;
    var node = root.document.querySelector('script[id^="CartJson-"]');
    if (!node) return;
    try { updateCart(JSON.parse(node.textContent)); } catch (error) { /* Keep server-rendered copy. */ }
  }
  return { init: init, productMode: productMode, classify: classify, updateCart: updateCart, freeShippingState: freeShippingState, formatShippingAmount: formatShippingAmount };
});
